export default [
  {
    name: 'schedules',
    path: '/schedules',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Programação',
      icon: 'dvr',
      label: 'Programação',
      permission: 'schedule.list'
    }
  },
  {
    name: 'schedule-edit',
    path: '/schedules/edit/:id',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Programação - Edição',
      icon: 'dvr',
      label: 'Programação - Edição',
      permission: 'schedule.edit'
    }
  },
  {
    name: 'schedule-new',
    path: '/schedules/novo',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Programação - Adicionar',
      icon: 'dvr',
      label: 'Programação - Adicionar',
      permission: 'schedule.add'
    }
  }
]
